import cx from 'classnames';
import { forwardRef } from 'react';
import type { MouseEventHandler, ReactElement } from 'react';

import { Button } from '@trello/nachos/button';
import type { TestId } from '@trello/test-ids';

import styles from './IslandNavButton.less';

interface IslandNavButtonProps {
  className?: string;
  icon: ReactElement;
  isDisabled?: boolean;
  isPrimary?: boolean;
  isSelected?: boolean;
  onClick?: MouseEventHandler<HTMLButtonElement>;
  testId?: TestId;
  title?: string;
}

export const IslandNavButton = forwardRef<
  HTMLButtonElement,
  IslandNavButtonProps
>(
  (
    {
      className,
      icon,
      isDisabled = false,
      isPrimary = false,
      isSelected = false,
      onClick,
      testId,
      title,
    },
    ref,
  ) => {
    return (
      <Button
        className={cx(styles.button, className, {
          [styles.primary]: isPrimary,
          [styles.selected]: isSelected,
        })}
        appearance="subtle"
        shouldFitContainer={true}
        isDisabled={isDisabled}
        onClick={onClick}
        ref={ref}
        title={title}
        testId={testId}
      >
        {icon}
        {isSelected && <span className={styles.indicator}></span>}
      </Button>
    );
  },
);
